import billingModule from '../../billing.module';

class BillingAccountService {
    constructor($q, billingAccountApiService) {
        this.$q = $q;
        this.billingAccountApiService = billingAccountApiService;

        this.promiseCache = {};
    }

    getBillingAccount() {
        return this.billingAccountApiService.getBillingAccount();
    }

    updateBillingAccount(account) {
        if (!account) {
            return this.$q.reject('falsyAccount');
        }

        let deferred = this.$q.defer();

        this.billingAccountApiService
            .updateBillingAccount(account)
            .then(
                data => deferred.resolve(data),
                data => deferred.reject(data)
            );

        return deferred.promise;
    }
}

export default billingModule.service(
    'billingAccountService',
    BillingAccountService
);



// WEBPACK FOOTER //
// ./modules/billing/services/account/billingAccount.service.js